module.exports = __webpack_public_path__ + "static/media/Cardo-Regular.1277762f.svg";